import React, { useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import LeadershipPageHeader from '@/components/LeadershipPageHeader';
import { LEADERSHIP_CONTENT } from '@/config/leadershipLayout';
import ClinicBookingConfigSection from '../components/ClinicBookingConfigSection';
import ClinicTariffConfigSection from '../components/ClinicTariffConfigSection';
import ReferralApprovalConfigSection from '@/modules/referral/components/ReferralApprovalConfigSection';

const TABS = [
  { key: 'booking', label: 'Booking' },
  { key: 'tariffs', label: 'Tariffs' },
  { key: 'referrals', label: 'Referral approvals' },
];

/** Clinic configuration — tabbed sections, each with its own Save. */
export default function BookingSettingsPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const tab = useMemo(() => {
    const t = (params.get('tab') || 'booking').toLowerCase();
    return TABS.some((x) => x.key === t) ? t : 'booking';
  }, [params]);

  const setTab = (key) => {
    navigate(`/management/booking-settings?tab=${key}`, { replace: true });
  };

  return (
    <div className={`${LEADERSHIP_CONTENT} space-y-5`} data-testid="booking-settings-page">
      <LeadershipPageHeader
        title="Configuration"
        subtitle="Booking rules, consultation tariffs, and out-station referral approval stages. Each section saves independently."
      />

      <div className="flex flex-wrap gap-1 rounded-xl bg-[#F4F7FA] p-1 w-fit" data-testid="config-tabs">
        {TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            onClick={() => setTab(t.key)}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
              tab === t.key
                ? 'bg-[#F15A22] text-white shadow-sm'
                : 'text-[#5A6B7C] hover:text-[#071B34]'
            }`}
            data-testid={`config-tab-${t.key}`}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="rounded-2xl border border-[#D5DEE8] bg-white p-5 sm:p-6 max-w-5xl">
        {tab === 'booking' ? <ClinicBookingConfigSection /> : null}
        {tab === 'tariffs' ? <ClinicTariffConfigSection /> : null}
        {tab === 'referrals' ? <ReferralApprovalConfigSection /> : null}
      </div>
    </div>
  );
}
